import { useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/85 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:h-20 md:px-10">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-semibold tracking-wide text-foreground-950">
            迷人的保姆
          </span>
        </a>

        <nav className="ml-6 hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <div className="flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索片名 / 字幕版本"
              className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none xl:w-52"
            />
          </div>
          <a
            href="#movies"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-circle-line text-base"></i>
            在线观看
          </a>
        </div>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300/70 text-foreground-900 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <div className="mb-3 flex items-center gap-2 rounded-full border border-background-300/70 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索片名 / 字幕版本"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
          </div>
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}